define('modules/shell/widgets/datepicker/i18n/ja',{
    "datepicker":{
        "clear":"クリア"
    }
});

